/** @format */
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-study-right-extension-workflow-payment-failed',
    templateUrl: './study-right-extension-workflow-payment-failed.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class StudyRightExtensionWorkflowPaymentFailedComponent {}
